import * as React from 'react';

import { AnalyticsStore, RouteStore } from 'bernie-core';

import { adaptListings } from 'src/common/stores/adapters/bex-api/migration-adapters/property-info/property-info-listings-adapter';
import { CurrentHotelStore } from 'stores/current-hotel-store';

import { LoadingPlaceholder } from './loading-placeholder';
import { OffersListings } from './offers-listings';

interface OffersListComposerProps {
  currentHotel?: CurrentHotelStore;
  analytics?: AnalyticsStore;
  routeStore?: RouteStore;
  soldOut?: boolean;
}

export const OffersListComposer: React.FunctionComponent<OffersListComposerProps> = ({ analytics, currentHotel, routeStore }) => {
  const { loadingOffers, searchCriteria, bexApiPropertyInfoOffersResponse, shouldFetchOffers } = currentHotel;

  const listings = bexApiPropertyInfoOffersResponse?.offers?.listings;

  if (loadingOffers || shouldFetchOffers) {
    return <LoadingPlaceholder />;
  }

  if (!listings?.length) {
    return null;
  }

  return (
    <OffersListings
      analytics={analytics}
      currentHotel={currentHotel}
      isDateless={searchCriteria.isDateless}
      listings={adaptListings(listings)}
      loadingOffers={loadingOffers}
      routeStore={routeStore}
    />
  );
};

OffersListComposer.displayName = 'OffersListComposer';
